/*
 * @Author: Wang_jun 1433207604@qq.com
 * @Date: 2022-03-02 15:28:27
 * @LastEditors: Wang_jun 1433207604@qq.com
 * @LastEditTime: 2023-04-25 16:23:48
 * @FilePath: /visaai-platform/src/plugins/router.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home'
import MessageList from '@/views/message/MessageList'
import Web from '@/views/Web'
import Financial from '@/views/financial/Financial'
import Coupon from '@/views/financial/Coupon'
import Malay from '@/views/financial/malay/Index'
import USA from '@/views/financial/usa/Index'
import Mall from '@/views/financial/mall/Index'
import WangdanIntroduction from '@/views/WangdanIntroduction'
import Recharge from "@/views/financial/recharge"
Vue.use(VueRouter)

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/message',
    name: 'MessageList',
    component: MessageList
  },
  {
    path: '/web/:type',
    name: 'Web',
    component: Web,
    props: true
  },
  {
    path: '/financial',
    name: 'Financial',
    component: Financial,
    children: [
      {
        path: '/financial/coupon',
        name: 'Coupon',
        component: Coupon
      },
      {
        path: '/financial/malay',
        name: 'Malay',
        component: Malay
      },
      {
        path: '/financial/usa',
        name: 'USA',
        component: USA
      },
      {
        path: '/financial/recharge',
        name: 'Recharge',
        component: Recharge
      },
      
      {
        path: '/financial/mall',
        name: 'Mall',
        component: Mall
      }
    ]
  },
  {
    path: '/wangdan-introduction',
    name: 'WangdanIntroduction',
    component: WangdanIntroduction
  }
]

const router = new VueRouter({
  routes
})


export default router
